var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gg:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.64821 23H13.0693V14.1468H17.0526L17.4903 9.74789H13.0693V7.52632C13.0693 7.23318 13.1857 6.95205 13.393 6.74478C13.6003 6.5375 13.8814 6.42105 14.1745 6.42105H17.4903V2H14.1745C12.7089 2 11.3032 2.58224 10.2668 3.61862C9.23045 4.65501 8.64821 6.06065 8.64821 7.52632V9.74789H6.43768L6 14.1468H8.64821V23Z",
    fill: "#0866FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFacebook);
export default __webpack_public_path__ + "static/media/login-facebook.9b368eb1e723cd53d489b1ea11ed24ae.svg";
export { ForwardRef as ReactComponent };